import Titanite from 'titanite-javascript';
import type { AddEventCallback, AmethystEvent, TitaniteConfig } from 'titanite-javascript';

import type { AmethystDeviceContext } from 'helpers/amethystDeviceContext';
import { getAmethystDeviceFields } from 'helpers/amethystDeviceContext';

export default class MartyTitanite extends Titanite {
  constructor(
    private readonly titaniteConfig: Partial<TitaniteConfig>,
    private readonly deviceContext?: AmethystDeviceContext
  ) {
    super(titaniteConfig);
  }

  withDeviceContext(event: AmethystEvent): AmethystEvent {
    if (!this.deviceContext || (this.titaniteConfig.eventType && this.titaniteConfig.eventType !== 'websiteEvent')) {
      return event;
    }
    // Undefined own keys prevent Titanite from replacing missing classification inputs with browser defaults.
    return { ...event, ...getAmethystDeviceFields(this.deviceContext) };
  }

  override addEvent(event: AmethystEvent, callback?: AddEventCallback, overrideDebounce?: boolean): void {
    super.addEvent(this.withDeviceContext(event), callback, overrideDebounce);
  }

  override addEvents(events: AmethystEvent[], callback?: AddEventCallback): void {
    super.addEvents(
      events.map(event => this.withDeviceContext(event)),
      callback
    );
  }
}
